import $ from "jquery";


export const initVideoPlayer = function() {
   console.log("Init Video Player");
   $('#play-video').on('click', function(e) {

        console.log("play-video clicked");
        $('#play-video-background').hide();
        $(this).hide();
        $("#video")[0].src += "&autoplay=1";
        e.preventDefault();
    });
};